export default {
  name: 'claimed_home_landing',

  data() {
    return {
      cash: false,
      buyer: false,
      listing: false,
    }
  },

  props: {
    property: {
      type: Object,
      default: () => {},
    },
    marketInfo: {
      type: Object,
      default: () => {},
    }
  },
}
